<template>
  <div class="page-demo">
    <!--banner-->
    <div class="banner">
      <div class="container">
        <h2 class="timeline">所有游戏</h2>
      </div>
    </div>
    <!--banner-->

    <!--游戏分类 start-->
    <div class="container" style="padding:2em 0;">
      <div class="games tj">
      </div>
      <div class="sap_tabs">

        <div id="horizontalTab" style="display: block; width: 100%; margin: 0px;">
          <ul class="resp-tabs-list">
            <li class="text">常用：</li>
            <li class="resp-tab-item" @click="getItem(36)"><span>推荐</span></li>
            <li class="resp-tab-item" @click="getItem(52)"><span>必玩</span></li>
            <li class="resp-tab-item" @click="getItem(54)"><span>自制</span></li>
            <li class="resp-tab-item" @click="getItem(53)"><span>投稿</span></li>
            <li class="resp-tab-item" @click="getItem(40)"><span>最近更新</span></li>
            <li class="resp-tab-item" @click="getItem(61)"><span>抽奖</span></li>
            <div class="clearfix"></div>
          </ul>
          <ul class="resp-tabs-list">
            <li class="text">语言：</li>
            <li class="resp-tab-item" @click="getItem(1)"><span>已汉化</span></li>
            <li class="resp-tab-item" @click="getItem(2)"><span>汉化中</span></li>
            <li class="resp-tab-item" @click="getItem(14)"><span>英文</span></li>
            <li class="resp-tab-item" @click="getItem(15)"><span>日文</span></li>
            <li class="resp-tab-item" @click="getItem(50)"><span>油猴汉化</span></li>
            <div class="clearfix"></div>
          </ul>
          <ul class="resp-tabs-list">
            <li class="text">平台：</li>
            <li class="resp-tab-item" @click="getItem(13)"><span>K站</span></li>
            <li class="resp-tab-item" @click="getItem(51)"><span>itch.io</span></li>
            <li class="resp-tab-item" @click="getItem(18)"><span>PC</span></li>
            <li class="resp-tab-item" @click="getItem(19)"><span>Steam</span></li>
            <li class="resp-tab-item" @click="getItem(16)"><span>安卓</span></li>
            <li class="resp-tab-item" @click="getItem(17)"><span>苹果</span></li>
            <li class="resp-tab-item" @click="getItem(34)"><span>微信</span></li>
            <div class="clearfix"></div>
          </ul>
          <ul class="resp-tabs-list">
            <li class="text">类型：</li>
            <li
                v-for="t in filteredTypeList"
                class="resp-tab-item"
                :key="t"
                @click="getItem(t)">
              <span>{{ t }}</span></li>
            <div class="clearfix"></div>
          </ul>
          <ul class="resp-tabs-list">
            <li class="text">筛选：</li>
            <li v-for="(t,index) in sortTypeList" class="resp-tab-item no-color" :key="index"><span>{{ t }}</span><em
                @click="delItem(t)">X</em></li>
            <li class="resp-tab-item reset" @click="clearSortItem()"><span>清空</span></li>
            <div class="clearfix"></div>
          </ul>
          <div class="resp-tabs-container">
            <div
                class="tab-1 resp-tab-content"
                :aria-labelledby="'tab_item-'+activeClass">
              <section>
                <div class="col-md-12 bottom-content no-plr games-list">
            <div
                class="col-md-3 blog-top"
                v-for="(game,index) in gameData"
                :key="index">
              <router-link :to="'/game/'+game.path" :title="game.title" target="_blank" v-if="!game.flash">
                <div class="blog-in">
                  <div class="face-box" :title="game.title">
                    <el-image class="img-responsive" :src="jietuUrl('static/images/game/'+game.path+'/jietu-1', game.imgExt)" :alt="game.title">
                      <div slot="placeholder" class="img-placeholder home">
                        图片加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                    <div class='MarkBox' v-if="checkDaysDifference(game.update)">
                      <div class='insideBox update'>更新</div>
                    </div>
                    <div class='MarkBox' v-if="checkDaysDifference(game.date)">
                      <div class='insideBox'>新发</div>
                    </div>
                    <div class='MarkBox' v-if="game.tuijian === 1">
                      <div class='insideBox tuijian'>推荐</div>
                    </div>
                    <div class='MarkBox' v-if="game.hot === 1">
                      <div class='insideBox hot'>热门</div>
                    </div>
                    <div class='MarkBox' v-if="game.biwan === 1">
                      <div class='insideBox biwan'>必玩</div>
                    </div>
                  </div>
                  <div class="blog-grid">
                    <h4><a>{{ game.title }}
                      <div v-if="game.enTitle">（{{ game.enTitle }}）</div>
                    </a></h4>
                    <div class="date">
                      <span class="date-in" title="发布日期"><i
                          class="glyphicon glyphicon-time"> </i>{{ game.date }}</span>
                      <span class="date-in recent" title="最后更新日期" v-if="game.update"><i
                          class="glyphicon glyphicon-repeat"> </i>{{ game.update }}</span>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </router-link>
            <!--Flash-->
              <a :href="'static/flash/'+game.path+'.html'" :title="game.title" target="_blank" v-if="game.flash">
                <div class="blog-in">
                  <div class="face-box" :title="game.title">
                    <el-image class="img-responsive" :src="jietuUrl('static/images/game/'+game.path+'/jietu-1', game.imgExt)" :alt="game.title">
                      <div slot="placeholder" class="img-placeholder home">
                        图片加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                    <div class='MarkBox' v-if="checkDaysDifference(game.date)">
                      <div class='insideBox'>新发</div>
                    </div>
                    <div class='MarkBox' v-if="game.tuijian === 1">
                      <div class='insideBox tuijian'>推荐</div>
                    </div>
                    <div class='MarkBox' v-if="game.hot === 1">
                      <div class='insideBox hot'>热门</div>
                    </div>
                    <div class='MarkBox' v-if="game.biwan === 1">
                      <div class='insideBox biwan'>必玩</div>
                    </div>
                  </div>
                  <div class="blog-grid">
                    <h4><a>{{ game.title }}
                      <div v-if="game.enTitle">（{{ game.enTitle }}）</div>
                    </a></h4>
                    <div class="date">
                      <span class="date-in" title="发布日期"><i
                          class="glyphicon glyphicon-time"> </i>{{ game.date }}</span>
                      <span class="date-in recent" title="最后更新日期" v-if="game.update"><i
                          class="glyphicon glyphicon-repeat"> </i>{{ game.update }}</span>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="clearfix"></div>
                <!-- <ul id="da-thumbs" class="da-thumbs">
                  <li v-for="(game, index) in gameData" :key="index"> -->
                    <!--非Flash-->
                    <!-- <em class="b-link-stripe b-animate-go  thickbox" v-if="!game.flash">
                      <router-link :to="'/game/'+game.path" :title="game.title" target="_blank">
                        <div class="face-box games" :title="game.title">
                          <el-image class="img-responsive" :src="jietuUrl('static/images/game/'+game.path+'/jietu-1', game.imgExt)" :alt="game.title">
                            <div slot="placeholder" class="img-placeholder small">
                              图片加载中<span class="dot">...</span>
                            </div>
                          </el-image>
                        </div>
                      </router-link>
                      <div>
                        <h5>
                          {{ game.title }}
                          <span v-if="game.version">v {{ game.version }}</span>
                          <span v-if="!game.version"> </span>
                        </h5>
                        <p>
                          <router-link
                              class="hvr-wobble-top"
                              :to="'/game/'+game.path"
                              :title="game.title"
                              target="_blank">
                            看介绍
                          </router-link>
                          <a
                              class=" hvr-wobble-top"
                              v-if="game.zhUrl || game.enUrl"
                              :href="game.zhUrl?game.zhUrl:game.enUrl"
                              target="_blank">玩游戏</a>
                          <a
                              class=" hvr-wobble-top"
                              v-if="!game.zhUrl && !game.enUrl && game.customUrl"
                              :href="game.customUrl"
                              target="_blank">玩游戏</a>
                        </p>
                      </div>
                    </em> -->
                    <!--Flash-->
                    <!-- <em class="b-link-stripe b-animate-go  thickbox" v-if="game.flash">
                      <a :href="'static/flash/'+game.path+'.html'" :title="game.title" target="_blank">
                        <div class="face-box games" :title="game.title">
                          <el-image class="img-responsive" :src="jietuUrl('static/images/game/'+game.path+'/jietu-1', game.imgExt)" :alt="game.title">
                            <div slot="placeholder" class="img-placeholder small">
                              图片加载中<span class="dot">...</span>
                            </div>
                          </el-image>
                        </div>
                      </a>
                      <div>
                        <h5>
                          {{ game.title }}
                          <span v-if="game.version">v {{ game.version }}</span>
                          <span v-if="!game.version"> </span>
                        </h5>
                        <p>
                          <a
                              class=" hvr-wobble-top"
                              :href="'static/flash/'+game.path+'.html'"
                              :title="game.title"
                              target="_blank">
                            看介绍
                          </a>
                          <a
                              class=" hvr-wobble-top"
                              :href="'static/flash/'+game.path+'.html'"
                              :title="game.title"
                              target="_blank">
                            玩游戏
                          </a>
                        </p>
                      </div>
                    </em>
                  </li>

                  <div class="clearfix"></div>
                </ul> -->
              </section>
            </div>
          </div>
          <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[12, 30, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!--游戏分类 end-->
  </div>
</template>

<script>
import imageExt from '@/mixins/imageExt'

export default {
  name: 'Demo',
  mixins: [imageExt],
  components: {},
  data() {
    return {
      total: 0,
      currentPage: 1,
      pagesize: 12,
      typeList: [],
      sortTypeList: [],
      gameList: [],
      curType: '全部游戏',
      activeClass: 0
    }
  },
  created() {
    this.getSetting()
    this.getType()
  },
  computed: {
    filteredTypeList() {
      const excludedIndices = [0, 1, 2, 13, 14, 15, 16, 17, 18, 19, 34, 36, 40, 50, 51, 52, 53, 54]
      return this.typeList.filter((t, index) => !excludedIndices.includes(index))
    },
    gameData() {
      return this.gameList.slice((this.currentPage - 1) * this.pagesize, this.currentPage * this.pagesize)
    }
  },
  methods: {
    getSetting() {
      const timeStamp = new Date().getTime()
      // 获取网站配置，存入本地储存
      this.$http.get('static/data/setting.json' + '?' + timeStamp).then(game => {
        // 如果本地有记录，对比配置版本号是否一致
        if(localStorage.getItem('settingList') && (game.data[0].version === JSON.parse(localStorage.getItem('settingList'))[0].version)){
          // 读取本地json
          this.getStaticData()
        } else {
          // 读取远程json
          this.getData()
          // 覆盖本地版本号
          localStorage.setItem('settingList', JSON.stringify(game.data))
        }
      })
    },
    getType() {
      const timeStamp = new Date().getTime()
      this.$http.get('static/data/type.json' + '?' + timeStamp).then(res => {
        const obj = res.data[0]
        this.typeList = Object.keys(obj).sort((a, b) => a - b).map(k => obj[k])
        this.curType = this.typeList[this.activeClass]
      })
    },
    getData() {
      const timeStamp = new Date().getTime()
      this.$http.get('static/data/games.json' + '?' + timeStamp).then(game => {
        localStorage.setItem('gameList', JSON.stringify(game.data))
        const activeGames = game.data.filter(g => g.status === 1)

        if (this.curType === '全部游戏') {
          this.gameList = activeGames
          .filter(g => g.update)
          .sort((a, b) => Date.parse(b.update) - Date.parse(a.update))
        } else if (this.curType === '最近更新' && this.sortTypeList.length === 1) {
          this.gameList = activeGames
          .filter(g => g.update)
          .sort((a, b) => Date.parse(b.update) - Date.parse(a.update))
        } else {
          this.gameList = activeGames.filter(g =>
            this.sortTypeList.every(sortType => g.type.includes(sortType))
          )
        }

        this.total = this.gameList.length

        if (this.gameList.length < 1) {
          this.$notify({
            title: '提示',
            message: '没找到你要查找的游戏，您可以减少筛选条件试试~',
            type: 'warning',
            duration: 1500
          })
        }
      })
    },
    getStaticData() {
       var gameArr=JSON.parse(localStorage.getItem('gameList'))
       if(gameArr){
        const activeGames = JSON.parse(localStorage.getItem('gameList')).filter(g => g.status !== 0)

        if (this.curType === '全部游戏') {
          this.gameList = activeGames
          .filter(g => g.update)
          .sort((a, b) => Date.parse(b.update) - Date.parse(a.update))
        } else if (this.curType === '最近更新' && this.sortTypeList.length === 1) {
          this.gameList = activeGames
          .filter(g => g.update)
          .sort((a, b) => Date.parse(b.update) - Date.parse(a.update))
        } else {
          this.gameList = activeGames.filter(g =>
            this.sortTypeList.every(sortType => g.type.includes(sortType))
          )
        }

        this.total = this.gameList.length

        if (this.gameList.length < 1) {
          this.$notify({
            title: '提示',
            message: '没找到你要查找的游戏，您可以减少筛选条件试试~',
            type: 'warning',
            duration: 1500
          })
        }
       }else{
        this.getData()
       }
    },
    getItem(indexOrType) {
      const index = typeof indexOrType === 'number' ? indexOrType : this.typeList.indexOf(indexOrType)
      this.activeClass = index
      this.gameList = []
      this.curType = this.typeList[index]

      if (index !== 0) {
        if (!this.sortTypeList.includes(this.curType)) {
          this.sortTypeList.push(this.curType)
        }
      }

      if (this.sortTypeList.length === 0) {
        this.curType = '全部游戏'
      }
        if(localStorage.getItem('gameList')){
          // 读取本地json
          this.getStaticData()
        } else {
          this.getData()
        }
      this.currentPage = 1
    },
    delItem(text) {
      this.sortTypeList = this.sortTypeList.filter(item => item !== text)
      if (this.sortTypeList.length > 0) {
        this.curType = this.sortTypeList[this.sortTypeList.length - 1]
      } else {
        this.curType = '全部游戏'
      }
      this.gameList = []
        if(localStorage.getItem('gameList')){
          // 读取本地json
          this.getStaticData()
        } else {
          this.getData()
        }
      this.currentPage = 1
    },
    clearSortItem() {
      if (this.sortTypeList.length !== 0) {
        this.sortTypeList = []
        this.gameList = []
        this.curType = '全部游戏'
        if(localStorage.getItem('gameList')){
          // 读取本地json
          this.getStaticData()
        } else {
          this.getData()
        }
        this.currentPage = 1
      } else {
        this.$notify({
          title: '提示',
          message: '请选择一个筛选条件',
          type: 'warning',
          duration: 1500
        })
      }
    },
    handleSizeChange(size) {
      this.pagesize = size
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
    },
    checkDaysDifference(date) {
      const now = new Date();
      const otherDate = new Date(date); // 示例日期，根据需要替换
      const timeDifference = now.getTime() - otherDate.getTime();
      const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
      return daysDifference < 7; // 更新数据属性以供模板使用
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
